import React from "react";

/**
 * A line named on the row itself: the line's colour name printed in that colour
 * ("Dk Blue Line"), in place of the bare dot the rows carried before, which
 * needed the footer key to be read at all.
 *
 * `headName` puts the head of that line in front of the colour — "Josephine •
 * Coral Line". Wide layouts only, on the reports that have the width for a line
 * column; a phone drops the column and reads its lines off DashboardColorLegend
 * in the footer instead.
 */
export default function DashboardLineColorName({
  colorName,
  hexCode,
  suffix = " Line",
  headName = "",
}) {
  if (!colorName) return null;

  return (
    <span className="dashboard-detail-line-name" style={{ color: hexCode }}>
      {headName ? (
        <>
          {headName}
          <span
            className="dashboard-detail-line-name-separator"
            aria-hidden="true"
          >
            {" • "}
          </span>
        </>
      ) : null}
      {colorName}
      {suffix}
    </span>
  );
}
